import React, { FunctionComponent } from 'react';

import { features } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';

import PageSectionCards, {
  PageSectionCardsProps,
} from 'components/page/sections/page-section-cards';

export const TravelModeBlockThreeContainer: FunctionComponent = () => {
  const props = {
    title: features.travelMode.lxTravelModeThreeBlockTitle,
    items: [
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/travel-mode/travel-mode-love-travel-mode-1.svg`,
        title: features.travelMode.lxTravelModeThreeBlockSubtitleOne,
        text: features.travelMode.lxTravelModeThreeBlockBodyTextOne,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/travel-mode/travel-mode-love-travel-mode-2.svg`,
        title: features.travelMode.lxTravelModeThreeBlockSubtitleTwo,
        text: features.travelMode.lxTravelModeThreeBlockBodyTextTwo,
        titleTag: 'h3',
      },
      {
        imageSrc: `${CdnImagePath}/landing/assets/illustrations/features/travel-mode/travel-mode-love-travel-mode-3.svg`,
        title: features.travelMode.lxTravelModeThreeBlockSubtitleThree,
        text: features.travelMode.lxTravelModeThreeBlockBodyTextThree,
        titleTag: 'h3',
      },
    ] as PageSectionCardsProps['cards'],
  };

  return <PageSectionCards title={props.title} cards={props.items} color="white" />;
};
